import { useCallback, useEffect, useRef, useState } from 'react'


export const MAP_CELL_ATTR = 'data-map-cell'

export interface OpenCell {
  key: string
  anchorEl: HTMLElement
}


export function useCellSummary<T extends HTMLElement = HTMLDivElement>() {
  const containerRef = useRef<T>(null)
  const [open, setOpen] = useState<OpenCell | null>(null)

  const close = useCallback(() => setOpen(null), [])

  useEffect(() => {
    if (open === null) return

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      const cell = target?.closest(`[${MAP_CELL_ATTR}]`)
      if (!cell || !containerRef.current?.contains(cell)) setOpen(null)
    }

    document.addEventListener('mousedown', handleMouseDown)
    return () => document.removeEventListener('mousedown', handleMouseDown)
  }, [open])

  return { containerRef, open, setOpen, close }
}
